// extracted by mini-css-extract-plugin
export var darkBlue = "#003e52";
export var darkGreen = "#3b693d";
export var green = "#3dae2b";
export var lightGreen = "#93d500";
export var newsGreen = "#ecf5d7";
export var orange = "#f90";
export var yellow = "#fbc900";
export var paleBlue = "#64a1bb";
export var blue = "#67b9e8";
export var blueishGrey = "#adc6d6";
export var coolGrey = "#e1e2e0";
export var white = "#fff";
export var almostWhite = "#f2eded";
export var lightGrey = "#d3d3d3";
export var lightishGrey = "#aba9a9";
export var grey = "#828382";
export var darkishGrey = "#666";
export var darkGrey = "#4b4d4b";
export var almostBlack = "#333";
export var error = "#ff3a3a";
export var warning = "#ffd162";
export var success = "#1ebc7b";
export var section = "WidgetSection-module--section--2jA4o";
export var antiPoisonCenter = "WidgetSection-module--antiPoisonCenter--3MiXc";
export var antiPoisonName = "WidgetSection-module--antiPoisonName--S3dA5";
export var antiPoisonNumberWrapper = "WidgetSection-module--antiPoisonNumberWrapper--2a_T9";
export var antiPoisonNumber = "WidgetSection-module--antiPoisonNumber--wGiQN WidgetSection-module--antiPoisonName--S3dA5";
export var widgets = "WidgetSection-module--widgets--yR914";
export var weatherWidgetWrapper = "WidgetSection-module--weatherWidgetWrapper--28Xua";
export var bottomWidgetWrapper = "WidgetSection-module--bottomWidgetWrapper--rLyXd";
export var belowAntiPoisonNumber = "WidgetSection-module--belowAntiPoisonNumber--1eGBv";
export var bottomWidgetImage = "WidgetSection-module--bottomWidgetImage--PdeOy";
export var belowWeatherWidget = "WidgetSection-module--belowWeatherWidget--1KKt3";
export var nerthusContainer = "WidgetSection-module--nerthusContainer--3VvhH";
export var title = "WidgetSection-module--title--1fEdh";
export var subtitle = "WidgetSection-module--subtitle--2wbRc";
export var button = "WidgetSection-module--button--PNK6C";
export var noWeatherWidget = "WidgetSection-module--noWeatherWidget--386BF";